import React, { useState, useEffect } from "react";
import Div100vh from "react-div-100vh";
import { Plus, X } from "lucide-react";

import { updateFunction, trackBtnClick, trackPageView } from "@/lib/helper";
import { FAQ_CONTENT } from "@/lib/data";
import GoBackButton from "@/components/common/buttons/GoBackButton";

export default function FAQScreen() {
  const [openIndex, setOpenIndex] = useState(null);

  const handleToggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  useEffect(() => {
    trackPageView("Tenant FAQs", "Home Page CTA");
  }, []);

  return (
    <Div100vh className="flex flex-col justify-between py-5 px-4 gap-6 overflow-y-scroll">
      <GoBackButton />
      <div className="flex flex-col justify-between">
        <span className="px-4 text-xl font-semibold mb-4">FAQ's</span>
        {FAQ_CONTENT.map((faq, index) => (
          <div key={index} className="py-4 border-b border-[#555] ">
            <button
              onClick={() => handleToggle(index)}
              className="w-full text-left text-sm flex items-start justify-between px-4 py-2 focus:outline-none"
            >
              <span
                className={`font-normal pr-2 ${
                  openIndex === index ? "text-[#1987fb]" : ""
                }`}
              >
                {faq.question}
              </span>
              <span
                className={`${openIndex === index ? "" : "text-[#1987fb]"}`}
              >
                {openIndex === index ? <X size={18} /> : <Plus size={18} />}
              </span>
            </button>
            <div
              className={`${
                openIndex === index
                  ? "opacity-100 max-h-screen"
                  : "opacity-0 max-h-0"
              } transition-all duration-500 ease-in-out overflow-hidden`}
            >
              {/* <div className="px-4 text-xs">
                <p>{faq.answer}</p>
              </div> */}
              {faq.question !==
                "What are the charges for tenants & landlords?" && (
                <div className="px-4 text-xs md:text-lg">
                  <p>{faq.answer}</p>
                </div>
              )}
              {faq.question ===
                "What are the charges for tenants & landlords?" && (
                <div className="text-white p-6">
                  {/* Header Section */}
                  <div className="mb-6">
                    <p className="text-[#21DB05] font-semibold">
                      Tenant:{" "}
                      <span className="text-[#fff] font-medium">
                      3-4% of Platform fees is added to their monthly rent.
                      </span>
                    </p>
                    <p className="text-[#5AA7FF] font-bold mt-2">
                      Landlord:{" "}
                      <span className="text-[#fff] font-medium">
                      get advance rent of the entire lease at a 3-4% discount.
                      </span>
                    </p>
                  </div>

                  {/* Example Section */}
                  <div className="bg-[#222] p-4 text-sm italic leading-6">
                    <h3 className="text-center text-[#999] italic uppercase font-semibold mb-2 tracking-wider">
                      For Example:
                    </h3>
                    <div className="text-gray-200">
                      <p className="mb-4 font-normal italic">
                        Monthly Rent = ₹10,000/- <br /> Lease = 10 months.
                      </p>
                      <p className="text-[#21DB05] font-semibold mb-2">
                        For Tenant: <br />
                        <span className="font-normal text-[#eee]">
                        Monthly rent as No-Cost EMI: ₹10,000 + 4% Platform fees = ₹10,400/-.
                        </span>
                      </p>
                      <p className="text-[#5AA7FF] font-semibold">
                        For Landlord: <br />
                        <span className="font-normal text-[#eee] leading-6">
                        Advance rent of entire lease: (₹10,000 x 10) - 4% discount fees = ₹96,000 + 1 Month&apos;s rent as Security deposit.
                        </span>
                      </p>
                    </div>
                  </div>

                  {/* Footer Section */}
                  <div className="text-gray-500 text-sm mt-4 font-semibold">
                    GST applicable
                  </div>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </Div100vh>
  );
}
